import React from 'react'

export const Para = () => {
  return (
    <p className='para'>CHILL AND RELAX BUDDY!</p>
  )
}
